import "./skeleton-loader.css"

function SkeletonLoader({ rowCount = 5, columnCount = 5, hasActions = true }) {
  const renderDesktopSkeleton = () => (
    <div className="skeleton-table-container">
      <table className="skeleton-table">
        <thead>
          <tr>
            <th className="col-numero">#</th>
            {Array.from({ length: columnCount }).map((_, index) => (
              <th key={index}>
                <div className="skeleton-text skeleton-header"></div>
              </th>
            ))}
            {hasActions && <th className="col-actions">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex} className="skeleton-row">
              <td className="col-numero">
                <div className="skeleton-text skeleton-number"></div>
              </td>
              {Array.from({ length: columnCount }).map((_, colIndex) => (
                <td key={colIndex}>
                  <div className="skeleton-text"></div>
                </td>
              ))}
              {hasActions && (
                <td className="col-actions">
                  <div className="skeleton-actions">
                    <div className="skeleton-button"></div>
                    <div className="skeleton-button"></div>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )

  const renderMobileSkeleton = () => (
    <div className="skeleton-mobile-container">
      {Array.from({ length: rowCount }).map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-card-header">
            <div className="skeleton-text skeleton-number"></div>
            <div className="skeleton-text skeleton-badge"></div>
          </div>
          <div className="skeleton-card-body">
            {Array.from({ length: columnCount }).map((_, colIndex) => (
              <div key={colIndex} className="skeleton-card-row">
                <div className="skeleton-text skeleton-label"></div>
                <div className="skeleton-text skeleton-value"></div>
              </div>
            ))}
          </div>
          <div className="skeleton-card-actions">
            <div className="skeleton-button skeleton-button-large"></div>
            <div className="skeleton-button skeleton-button-large"></div>
          </div>
        </div>
      ))}
    </div>
  )

  return (
    <>
      <div className="desktop-view">{renderDesktopSkeleton()}</div>
      <div className="mobile-view">{renderMobileSkeleton()}</div>
    </>
  )
}

export default SkeletonLoader
